// extracted by mini-css-extract-plugin
module.exports =  {"container":"e2ff468f85--container--MUV7q","image":"e2ff468f85--image--hUyVI","description":"e2ff468f85--description--KmxdX"};